import { createFileRoute, Link } from "@tanstack/react-router";
import { ShieldCheck, Building2, HeartHandshake } from "lucide-react";
import { SiteShell } from "@/components/site-shell";

export const Route = createFileRoute("/demo")({
  head: () => ({ meta: [{ title: "Demo Login — Animal Seva" }] }),
  component: Demo,
});

const roles = [
  {
    to: "/admin",
    icon: ShieldCheck,
    title: "Super Admin",
    body: "Verify institutions, approve causes, monitor donations, manage CMS and reports.",
    color: "var(--maroon)",
  },
  {
    to: "/institution",
    icon: Building2,
    title: "Institution Admin",
    body: "Manage profile, create causes, track donations, post impact updates.",
    color: "var(--saffron-deep)",
  },
  {
    to: "/donor",
    icon: HeartHandshake,
    title: "Donor",
    body: "View donation history, receipts, favourites and impact updates.",
    color: "#4a7a6a",
  },
] as const;

function Demo() {
  return (
    <SiteShell>
      <section className="mx-auto max-w-5xl px-4 py-16 sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--saffron-deep)]">
          Demo mode
        </p>
        <h1 className="mt-2 font-display text-4xl font-semibold text-[var(--maroon-deep)]">
          Open any panel — instantly
        </h1>
        <p className="mt-3 max-w-2xl text-foreground/70">
          Animal Seva ships with a demo role switcher loaded with sample institutions, causes and
          donations. Pick a role to enter the corresponding dashboard.
        </p>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {roles.map((r) => (
            <Link
              key={r.to}
              to={r.to}
              className="group rounded-2xl border border-border/60 bg-card p-6 shadow-[var(--shadow-soft)] transition hover:-translate-y-0.5 hover:shadow-[var(--shadow-card)]"
            >
              <div
                className="grid h-11 w-11 place-items-center rounded-xl text-white"
                style={{ background: r.color }}
              >
                <r.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-4 font-display text-xl font-semibold">{r.title}</h3>
              <p className="mt-2 text-sm text-foreground/70">{r.body}</p>
              <p className="mt-5 text-sm font-semibold text-[var(--maroon)] group-hover:underline">
                Enter dashboard →
              </p>
            </Link>
          ))}
        </div>
      </section>
    </SiteShell>
  );
}
